/**
 * GENERATED by `tools/build-sprite-atlas.mjs` — do not hand-edit. [P9-art] [lane-sprites]
 *
 * Maps each of the 24 canonical base-game tile ids to the donor sprite-sheet cell(s) whose
 * (side terrain, feature partition, pennant) signature matches it, plus the quarter-turn
 * rotation needed so that cell's artwork reads correctly in the canonical orientation.
 */

export interface SpriteCandidate {
  readonly cellIndex: number;
  readonly rotation: 0 | 1 | 2 | 3;
}

export const SHEET_COLS = 17;
export const SHEET_ROWS = 3;
export const CELL_PX = 90;
export const SHEET_URL = '/sprites/base-sprite.png';

export const SPRITE_MAP: Readonly<Record<string, readonly SpriteCandidate[]>> = {
  A: [{ cellIndex: 33, rotation: 0 }, { cellIndex: 34, rotation: 0 }],
  B: [{ cellIndex: 48, rotation: 0 }, { cellIndex: 49, rotation: 0 }, { cellIndex: 50, rotation: 0 }],
  C: [{ cellIndex: 0, rotation: 0 }],
  D: [{ cellIndex: 23, rotation: 0 }, { cellIndex: 24, rotation: 0 }, { cellIndex: 25, rotation: 0 }],
  E: [{ cellIndex: 14, rotation: 0 }, { cellIndex: 15, rotation: 0 }, { cellIndex: 16, rotation: 0 }],
  F: [{ cellIndex: 5, rotation: 0 }],
  G: [{ cellIndex: 4, rotation: 0 }],
  H: [{ cellIndex: 12, rotation: 0 }, { cellIndex: 13, rotation: 0 }],
  I: [{ cellIndex: 10, rotation: 2 }, { cellIndex: 11, rotation: 2 }],
  J: [{ cellIndex: 26, rotation: 0 }, { cellIndex: 27, rotation: 0 }, { cellIndex: 28, rotation: 0 }],
  K: [{ cellIndex: 29, rotation: 0 }, { cellIndex: 30, rotation: 0 }, { cellIndex: 31, rotation: 0 }],
  L: [{ cellIndex: 32, rotation: 0 }],
  M: [{ cellIndex: 8, rotation: 0 }, { cellIndex: 9, rotation: 0 }],
  N: [{ cellIndex: 6, rotation: 0 }, { cellIndex: 7, rotation: 0 }],
  O: [{ cellIndex: 21, rotation: 0 }, { cellIndex: 22, rotation: 0 }],
  P: [{ cellIndex: 19, rotation: 0 }, { cellIndex: 20, rotation: 0 }],
  Q: [{ cellIndex: 3, rotation: 0 }],
  R: [{ cellIndex: 1, rotation: 0 }, { cellIndex: 2, rotation: 0 }],
  S: [{ cellIndex: 18, rotation: 0 }],
  T: [{ cellIndex: 17, rotation: 0 }],
  U: [{ cellIndex: 41, rotation: 1 }, { cellIndex: 42, rotation: 1 }, { cellIndex: 43, rotation: 1 }, { cellIndex: 44, rotation: 1 }, { cellIndex: 45, rotation: 1 }],
  V: [{ cellIndex: 35, rotation: 1 }, { cellIndex: 36, rotation: 1 }, { cellIndex: 37, rotation: 1 }, { cellIndex: 38, rotation: 1 }, { cellIndex: 39, rotation: 1 }, { cellIndex: 40, rotation: 1 }],
  W: [{ cellIndex: 46, rotation: 0 }],
  X: [{ cellIndex: 47, rotation: 0 }],
};
